import React from "react";
import { StatusToggleSwitch } from "../../../../StatusToggleSwitch";
import { inactiveGrade } from "../../../../../redux/features/assessmentToolSlice";

const GradeStatus = ({ params }) => {
    return (
        <StatusToggleSwitch
            disabled={params.has_child_element === 1 ? true : false}
            api={inactiveGrade(params.grade_id)}
            initialValue={params.grade_status === 0 ? true : false}
        />
    );
};

export default GradeStatus;
